import Vue from "vue";
import Router from "vue-router";
import auth from '@/api/auth.js';
import { msalInstance } from "vue-msal-browser";

import ErrorPage from "@/components/error/ErrorPage";
//import ContactUs from   '@/components/content/ContactUs'
Vue.use(Router);

async function requireAuth(to,from,next){
  msalInstance.handleRedirectPromise().then(res=>{
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
        const accessTokenRequest = {
          scopes:process.env.VUE_APP_MSAL_SCOPES.split(','),
          account: accounts[0]
        };
        msalInstance.acquireTokenSilent(accessTokenRequest).then((res) => {
        if(res.accessToken){
          auth.setAccessToken(res.accessToken);
          next();
        }else{
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      },err=>{
        auth.logout();
        });
  }else{
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
  },err=>{
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  });
}

function preventReLogin (to, from, next) {
  const accounts = msalInstance.getAllAccounts();
    if(accounts.length > 0){
        const accessTokenRequest = {
            scopes: process.env.VUE_APP_MSAL_SCOPES.split(','),
            account: accounts[0]
          };
        msalInstance.setActiveAccount(accounts[0]);
        msalInstance.acquireTokenSilent(accessTokenRequest).then(access=>{
          if(access){
            next();
          }
        });
    }else{
      next();
    }
  // auth.isLoggedIn().then(loggedIn => {
  //   if (loggedIn) {
  //     next()
  //   } else {
  //     next()
  //   }
  // })
}

export default new Router({
  mode: "history",
  base: Vue.config.BASE_URL,
  routes: [
    {
      path: "/login",
      name: "LoginView",
      component: () => import(/* webpackChunkName: "LoginView" */ '@/components/Login.vue'),
      beforeEnter: preventReLogin
    },
    {
      path: "/callback", 
      component: auth.handleCallback()
    },
    {
      path: "/",
      name: "home",
      component: () => import("@/components/home/Home"),
      beforeEnter: requireAuth,
    },
    {
      path: "/redeem/:couponCode",
      name: "coupon_validator",
      component: () => import("@/components/marketing/CouponValidator"),
      beforeEnter: requireAuth,
      props: route => ({
        couponCode: route.params.couponCode,
        programChoice: route.query.programChoice
      })
    },
    {
      path: "/program_choice/:couponCode",
      name: "program_choice",
      component: () => import("@/components/misc/ProgramChoice"),
      beforeEnter: requireAuth,
      props: route => ({
        couponCode: route.params.couponCode
      })
    },
    {
      path: "/order/:couponCode",
      name: "order",
      component: () => import("@/components/order/OrderPage"),
      beforeEnter: requireAuth,
      children: [
        {
          //start with order input
          path: "",
          name: "order_input",
          component: () => import("@/components/order/OrderInput"),
          beforeEnter: requireAuth,
        },
        {
          //order review
          path: "review",
          name: "order_review",
          component: () => import("@/components/order/OrderReview"),
          beforeEnter: requireAuth,
          props: true
        }
      ],
      props: route => ({
        couponCode: route.params.couponCode,
        programChoice: route.query.programChoice
      })
    },
    {
      //order review
      path: "process",
      name: "order_process",
      component: () => import("@/components/processor/OrderProcessor"),
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: "/error",
      component: ErrorPage,
      props: true
    },
    {
      path: "/status/:code",
      component: () => import("@/components/status/StatusPage"),
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: "/terms/:code",
      component: () => import("@/components/terms/TermsPage"),
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: "/printout/:confirmationNumber",
      component: () => import("@/components/confirmation/ConfirmationPage"),
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: "/confirmation/:confirmationNumber",
      component: () => import("@/components/confirmation/ConfirmationPage"),
      beforeEnter: requireAuth,
      props: true
    },
    {
      path: "/status",
      component: () => import("@/components/status/InputStatus"),
      beforeEnter: requireAuth,
      props: false
    },
    {
      path: "/support",
      component: () => import("@/components/content/Support.vue"),
      beforeEnter: requireAuth,
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
